import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, onyx, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingTop: indent * 0.5,
    overflow: 'hidden' as const,
    shadowColor: onyx,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 2,
  },
  loading: {
    marginVertical: 40,
  },
  targetContainer: {
    paddingHorizontal: indent,
    paddingVertical: indent * 0.4,
  },
  targetWithBorder: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
  lastTarget: {
    paddingBottom: indent * 0.5,
  },
});
